import React, { useState, useEffect } from 'react';
import ExploreIconRow from './explore-icon-row';
import Soundbite from './soundbite';

const ExploreSidebar = ({ title, descriptions, soundbite, autoplay, isEntrance, updateParentTimestamp }) => {
    
    const [sidebarClass, setSidebarClass] = useState('explore-sidebar');

    useEffect(() => {
        // Delay adding the 'open' class (e.g., 1 second = 1000ms)
        
        var counter = 1500;
        
        if (isEntrance) {
            counter = 3500;
        }
        const timer = setTimeout(() => {

            setSidebarClass('explore-sidebar open');
        }, counter); // Adjust delay as needed

        // Cleanup timeout if component unmounts
        return () => clearTimeout(timer);
        
    }, []);

    return (
        <div id='explore-sidebar' className={sidebarClass}>
            <div className='explore-sidebar-title'>
                <a href='/'><img src='/assets/svgs/chev.svg'></img><span>Home</span></a>
                <h2>
                    {title}
                    <small>Explore The Palace</small>
                </h2>
            </div>
            <div className='explore-sidebar-descriptions'>
                {descriptions.map((desc, i) => <p key={i}>{desc}</p>)}
            </div>

            {!isEntrance && 
                <div className='explore-sidebar-close content'>
                    <button className='btn' id='explore-sidebar-close-button'>Explore the Room</button>
                </div>
            }
            

            {isEntrance && <ExploreIconRow />}
            <div className='soundbite-buffer'></div>
            {soundbite &&
                <Soundbite 
                    title={soundbite.title}
                    subtitle={soundbite.subtitle}
                    description={soundbite.description}
                    src={soundbite.src}
                    narrators={soundbite.narrators}
                    narratorTimings={soundbite.narratorTimings}
                    autoplay={autoplay}
                    updateParentTimestamp={updateParentTimestamp}
                    explicit={soundbite.explicit}
                    citation={soundbite.citation}
                />
            }
        </div>
    )
}

export default ExploreSidebar;